import { auth } from '../firebase'

export const logErrorToDiscord = async (
  stacktrace: string,
  message: string
) => {
  const parsedStacktrace = stacktrace
    .split('\n')
    .filter((line) => line.includes('at'))
    .map((line) => {
      const parts = line.split(' ')
      const functionName = parts[1]
      const fileName = parts[3].split(':')[0]
      const lineNumber = parts[3].split(':')[1]
      return {
        functionName,
        fileName,
        lineNumber,
      }
    })

  const stack = parsedStacktrace
    .map((frame) => {
      return `    at ${frame.functionName} (${frame.fileName}:${frame.lineNumber}:${frame.lineNumber})`
    })
    .join('\n')
  const url = window.location.href
  const userAgent = navigator.userAgent

  const data = {
    content:
      `[Rewod Web App]\n${message}\nURL: ${url}\nUserAgent: ${userAgent}\n\`\`\`js`.substring(
        0,
        2000 - 8
      ) + `\n\`\`\``,
  }

  try {
    const response = await fetch(
      process.env.REACT_APP_DISCORD_WEBHOOK_URL as string,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }
    )

    const r = await response.text()
    if (!response.ok) {
      throw new Error(`Error: ${r}`)
    }
  } catch (error: any) {
    console.error('Failed to send message:', error)
    console.error("Error's message:", error.message)
    console.error('Message that tried to send:', data)
  }
}
